(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale', '$scope'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale, $scope) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;
        vm.currentLanguage = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        JhiLanguageService.getCurrent().then(function (language) {
            vm.currentLanguage = language;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
            vm.currentLanguage = languageKey;
            $scope.$emit('translateChanged', languageKey);
        }
    }
})();
